import { render, staticRenderFns } from "./TreibstofftankFormular.vue?vue&type=template&id=9622b16a"
import script from "./TreibstofftankFormular.vue?vue&type=script&lang=js"
export * from "./TreibstofftankFormular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports